export default __webpack_public_path__ + "static/media/apr2023-4.7daf7278.jpg";